import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="py-20 text-center">
      <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
      <Link to="/" className="text-filmspo-gold hover:underline">
        Go Home
      </Link>
    </section>
  );
}
